import {NgModule} from '@angular/core';
import {checkoutB2BTranslationChunksConfig, checkoutB2BTranslationsDe, checkoutB2BTranslationsEn} from '@spartacus/checkout/b2b/assets';
import {CheckoutB2BRootModule} from '@spartacus/checkout/b2b/root';
import {checkoutTranslationChunksConfig, checkoutTranslationsDe, checkoutTranslationsEn} from '@spartacus/checkout/base/assets';
import {CHECKOUT_FEATURE, CheckoutRootModule} from '@spartacus/checkout/base/root';
import {CmsConfig, I18nConfig, provideConfig} from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [CheckoutRootModule, CheckoutB2BRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () => import('./checkout-wrapper.module').then((m) => m.CheckoutWrapperModule),
        },
      },
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {en: checkoutTranslationsEn, de: checkoutTranslationsDe},
        chunks: checkoutTranslationChunksConfig,
      },
    } as I18nConfig),
    provideConfig({
      i18n: {
        resources: {en: checkoutB2BTranslationsEn, de: checkoutB2BTranslationsDe},
        chunks: checkoutB2BTranslationChunksConfig,
      },
    } as I18nConfig),
  ],
})
export class CheckoutFeatureModule {}
